/*
 * KR Kakao popup (snippets/kr-kakao-popup.liquid), Black Friday 2026.
 * The phase comes from the visitor's clock, not Liquid, because pages are CDN-cached.
 * Shows after 12s on a page, or ~1.5s into the 2nd+ page view of the session, at most once
 * a session; a close snoozes it 3 days, a CTA tap ends it for the campaign.
 * phaseAt / readState / shouldShow are pure and exported for tests/kr-kakao-popup.test.mjs.
 */
(() => {
  const PRE_END = Date.parse('2026-11-08T15:00:00Z'); // 11/9 00:00 KST
  const FINE_END = Date.parse('2026-11-29T15:00:00Z'); // 11/30 00:00 KST
  const LIVE_END = Date.parse('2026-11-30T15:00:00Z'); // 12/1 00:00 KST
  const SNOOZE = 3 * 24 * 60 * 60 * 1000;
  const KEY = {
    cta: 'naomi-kakao-bf2026-cta',
    closed: 'naomi-kakao-bf2026-closed',
    shown: 'naomi-kakao-bf2026-shown',
    views: 'naomi-kakao-bf2026-views',
  };

  const phaseAt = (now) => (now < PRE_END ? 'pre' : now < LIVE_END ? 'live' : null);

  // null when storage throws (private mode, blocked): the caller then never shows
  const readState = (local, session) => {
    try {
      return {
        cta: local.getItem(KEY.cta) === '1',
        closedAt: Number(local.getItem(KEY.closed)) || 0,
        shown: session.getItem(KEY.shown) === '1',
      };
    } catch {
      return null;
    }
  };

  const shouldShow = (state, now) =>
    Boolean(state && phaseAt(now) && !state.cta && !state.shown && !(now - state.closedAt < SNOOZE));

  if (typeof module === 'object') module.exports = { phaseAt, readState, shouldShow, KEY, SNOOZE };
  if (typeof document === 'undefined') return;

  const box = document.querySelector('[data-kr-kakao]');
  if (!box?.showModal) return;

  const set = (store, key, value) => {
    try {
      store.setItem(key, value);
    } catch {}
  };

  let views = 0;
  try {
    // a reload is not a second page view
    const reload = performance.getEntriesByType('navigation')[0]?.type === 'reload';
    views = (Number(sessionStorage.getItem(KEY.views)) || 0) + (reload ? 0 : 1);
    sessionStorage.setItem(KEY.views, String(views));
  } catch {}

  // reading the storage globals can itself throw when site data is blocked
  const ok = () => {
    try {
      return shouldShow(readState(localStorage, sessionStorage), Date.now());
    } catch {
      return false;
    }
  };
  const phase = phaseAt(Date.now());
  if (!ok()) return;

  box.querySelectorAll('[data-phase]').forEach((el) => (el.hidden = el.dataset.phase !== phase));
  if (Date.now() >= FINE_END) box.querySelector('[data-kr-kakao-fine]').hidden = true;

  const trigger = views >= 2 ? 'pageview' : 'timer';
  const track = (event, props) => {
    try {
      if (window.NaomiPostHog?.ready) window.posthog?.capture(event, { phase, trigger, ...props });
    } catch {}
  };

  // start fetching the photo now so the card never opens without it
  const photo = box.querySelector('.kr-kakao__photo');
  photo.loading = 'eager';

  const busy = () =>
    document.querySelector('dialog[open], cart-drawer.active, details.menu-opening') ||
    /\boverflow-hidden/.test(document.body.className);

  let opener = null;
  let scrollY = 0;
  let method = null;
  let retried = false;

  const open = async () => {
    // never open (and spend the session's one show) in a background tab
    if (document.hidden) return document.addEventListener('visibilitychange', open, { once: true });
    if (busy()) {
      if (!retried) setTimeout(open, 4000);
      retried = true;
      return;
    }
    // re-check: another tab may have closed or tapped it meanwhile
    if (!ok()) return;
    await photo.decode().catch(() => {});
    if (busy()) return;
    opener = document.activeElement;
    scrollY = window.scrollY;
    document.body.classList.add('overflow-hidden');
    box.showModal();
    box.focus({ preventScroll: true }); // land on the dialog, not the X, so no focus ring shows at open
    requestAnimationFrame(() => requestAnimationFrame(() => box.classList.add('is-in')));
    set(sessionStorage, KEY.shown, '1');
    track('kakao_popup_shown');
  };

  box.addEventListener('cancel', () => (method = method || 'escape'));
  box.addEventListener('click', (event) => {
    if (event.target.closest('[data-kr-kakao-cta]')) {
      method = 'cta';
      set(localStorage, KEY.cta, '1');
      track('kakao_popup_cta');
      box.close(); // the link's own default still opens the channel in a new tab
      return;
    }
    if (event.target.closest('[data-kr-kakao-close]')) {
      method = 'x';
      return box.close();
    }
    // a click on the ::backdrop targets the dialog itself, outside its box
    const r = box.getBoundingClientRect();
    const out = event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom;
    if (event.target === box && out) {
      method = 'backdrop';
      box.close();
    }
  });
  box.addEventListener('close', () => {
    box.classList.remove('is-in');
    document.body.classList.remove('overflow-hidden');
    if (window.scrollY !== scrollY) window.scrollTo(0, scrollY);
    if (opener && opener !== document.body) opener.focus?.({ preventScroll: true });
    if (method !== 'cta') {
      set(localStorage, KEY.closed, String(Date.now()));
      track('kakao_popup_closed', { method: method || 'escape' });
    }
  });

  setTimeout(open, trigger === 'pageview' ? 1500 : 12000);
})();
